/**
 * sco design system — size tokens.
 * Source of truth. Edit directly.
 */

import { defineTokens } from '@chakra-ui/react'

export const sizes = defineTokens.sizes({
  container: {
    sm: { value: '480px' },
    md: { value: '768px' },
    lg: { value: '992px' },
    xl: { value: '1280px' },
    '2xl': { value: '1400px' },
    '3xl': { value: '1600px' },
  },
  '0.5': {
    value: '0.125em',
  },
  '1': {
    value: '0.25em',
  },
  '1.5': {
    value: '0.375em',
  },
  '2': {
    value: '0.5em',
  },
  '2.5': {
    value: '0.625em',
  },
  '3': {
    value: '0.75em',
  },
  '3.5': {
    value: '0.875em',
  },
  '4': {
    value: '1em',
  },
  '4.5': {
    value: '1.125em',
  },
  '5': {
    value: '1.25em',
  },
  '6': {
    value: '1.5em',
  },
  '7': {
    value: '1.75em',
  },
  '8': {
    value: '2em',
  },
  '9': {
    value: '2.25em',
  },
  '10': {
    value: '2.5em',
  },
  '11': {
    value: '2.75em',
  },
  '12': {
    value: '3em',
  },
  '14': {
    value: '3.5em',
  },
  '16': {
    value: '4em',
  },
  '20': {
    value: '5em',
  },
  '24': {
    value: '6em',
  },
  '28': {
    value: '7em',
  },
  '32': {
    value: '8em',
  },
  '36': {
    value: '9em',
  },
  '40': {
    value: '10em',
  },
  '44': {
    value: '11em',
  },
  '48': {
    value: '12em',
  },
  '52': {
    value: '13em',
  },
  '56': {
    value: '14em',
  },
  '60': {
    value: '15em',
  },
  '64': {
    value: '16em',
  },
  '72': {
    value: '18em',
  },
  '80': {
    value: '20em',
  },
  '96': {
    value: '24em',
  },
  '3xs': {
    value: '14em',
  },
  '2xs': {
    value: '16em',
  },
  xs: {
    value: '20em',
  },
  sm: {
    value: '24em',
  },
  md: {
    value: '28em',
  },
  lg: {
    value: '32em',
  },
  xl: {
    value: '36em',
  },
  '2xl': {
    value: '42em',
  },
  '3xl': {
    value: '48em',
  },
  '4xl': {
    value: '56em',
  },
  '5xl': {
    value: '64em',
  },
  '6xl': {
    value: '72em',
  },
  '7xl': {
    value: '80em',
  },
  '8xl': {
    value: '90em',
  },
  '1/2': {
    value: '50%',
  },
  '1/3': {
    value: '33.333333%',
  },
  '2/3': {
    value: '66.666667%',
  },
  '1/4': {
    value: '25%',
  },
  '3/4': {
    value: '75%',
  },
  '1/5': {
    value: '20%',
  },
  '2/5': {
    value: '40%',
  },
  '3/5': {
    value: '60%',
  },
  '4/5': {
    value: '80%',
  },
  '1/6': {
    value: '16.666667%',
  },
  '2/6': {
    value: '33.333333%',
  },
  '3/6': {
    value: '50%',
  },
  '4/6': {
    value: '66.666667%',
  },
  '5/6': {
    value: '83.333333%',
  },
  '1/12': {
    value: '8.333333%',
  },
  '2/12': {
    value: '16.666667%',
  },
  '3/12': {
    value: '25%',
  },
  '4/12': {
    value: '33.333333%',
  },
  '5/12': {
    value: '41.666667%',
  },
  '6/12': {
    value: '50%',
  },
  '7/12': {
    value: '58.333333%',
  },
  '8/12': {
    value: '66.666667%',
  },
  '9/12': {
    value: '75%',
  },
  '10/12': {
    value: '83.333333%',
  },
  '11/12': {
    value: '91.666667%',
  },
  max: {
    value: 'max-content',
  },
  min: {
    value: 'min-content',
  },
  fit: {
    value: 'fit-content',
  },
  prose: {
    value: '60ch',
  },
  full: {
    value: '100%',
  },
  dvh: {
    value: '100dvh',
  },
  svh: {
    value: '100svh',
  },
  lvh: {
    value: '100lvh',
  },
  dvw: {
    value: '100dvw',
  },
  svw: {
    value: '100svw',
  },
  lvw: {
    value: '100lvw',
  },
  vw: {
    value: '100vw',
  },
  vh: {
    value: '100vh',
  },
})
